import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import type { CustomComponentFilterProps as Props } from './types';

export const CustomComponentFilter = memo(
  ({ className, customComponent }: Props) => {
    if (!customComponent) {
      return null;
    }

    return (
      <Box className={classnames('CustomComponentFilter', className)}>
        {customComponent}
      </Box>
    );
  }
);

CustomComponentFilter.displayName = 'CustomComponentFilter';
